import { useEffect, useState } from "react";
import { pageIndicator, serviceId } from "../apollo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TopBar } from "../components/topBar";
import { useListAddress } from "../hooks/useListAddress";
import { useInjectKakaoMapApi, Map, MapMarker } from "react-kakao-maps-sdk";
import { useChkAddressArea } from "../hooks/useChkAddressArea";
import { Alert, CircularProgress, Collapse, Dialog, Fade } from "@mui/material";
import { HowToReceive } from "../constants/props";
import { useUpReceiptAddress } from "../hooks/useUpReceiptAddress";
import { useMe } from "../hooks/useME";
import { IAddress } from "../constants/types";
import {
  ChkAddressAreaInput,
  ChkAddressAreaQuery,
  ListAddressQuery,
  UpReceiptAddressInput,
  UpReceiptAddressMutation,
} from "../gql/graphql";
import {
  GetPortByLocationQuery,
  ListPortByLocationQuery,
  useListPortByLocation,
} from "../hooks/useListPortByLocation";
import { useReactiveVar } from "@apollo/client";
import { AlertComponent } from "../components/alert";

export const SelectReceiveWays = () => {
  const navigate = useNavigate();
  const state = useLocation().state as { serviceId: number };
  const params = useParams();
  const { data: me } = useMe();
  const [RestLoading, setRestLoading] = useState<boolean>(false);
  const [selectedAddress, setSelectedAddress] = useState<IAddress>();
  const [selectedPort, setSelectedPort] =
    useState<GetPortByLocationQuery["getPortByLocation"]["port"]>();
  const [portList, setPortList] =
    useState<ListPortByLocationQuery["listPortByLocation"]["ports"]>();
  const selectPort_serviceId = useReactiveVar(serviceId);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertText, setAlertText] = useState<string | undefined>("");
  const closeAlert = () => {
    setAlertOpen(false);
    navigate("/");
  };
  // 서비스 지역 다를 경우
  useEffect(() => {
    if (
      selectPort_serviceId !== 0 &&
      state.serviceId !== selectPort_serviceId
    ) {
      setAlertText("서비스 지역이 정보가 다릅니다. <br/> 다시 진행해주세요.");
      setAlertOpen(true);
    }
  }, [state, selectPort_serviceId]);

  const onListAddress = (data: ListAddressQuery) => {
    const {
      listAddress: { ok, address },
    } = data;
    if (ok && address) {
      var repAddress;
      if (state) {
        repAddress = address.find((a) => a.id === Number(state));
      } else {
        repAddress = address.find((a) => a.isRep === true);
      }
      setSelectedAddress(repAddress as IAddress);
    }
  };

  const [listAddress, { data: listAddressData }] =
    useListAddress(onListAddress);
  const listAddressHandler = () => {
    listAddress();
  };

  // 포트 리스트
  const onPortList = (data: ListPortByLocationQuery) => {
    const {
      listPortByLocation: { ok, err, ports },
    } = data;
    console.log(ports);
    if (ok && ports && ports.length > 0) {
      setPortList(ports);
    } else {
      console.log(err);
      setPortList([]);
    }
  };
  const [listPortByLocation] = useListPortByLocation(onPortList);
  useEffect(() => {
    pageIndicator("픽업장소 선택");
    listAddressHandler();
  }, []);

  useEffect(() => {
    if (selectPort_serviceId > 0) {
      listPortByLocation({
        variables: {
          input: {
            serviceId: Number(selectPort_serviceId),
          },
        },
      });
    }
  }, [selectPort_serviceId]);
  // receipt 저장
  const onUpReceiptAddress = (data: UpReceiptAddressMutation) => {
    const {
      upReceiptAddress: { ok, err },
    } = data;
    if (ok) {
      navigate(`/payment/${params.receiptUuid}`, {
        state: selectedAddress?.id,
      });
    } else {
      alert(err);
    }
  };
  const [upReceiptAddress] = useUpReceiptAddress(onUpReceiptAddress);
  const upReceiptAddressHandler = () => {
    if (!selectedPort) {
      alert("포트를 선택해주세요");
      return;
    }
    // 픽업(포장) 주문은 저장된 배송지가 없어도 진행할 수 있어서 selectedAddress가 비어있을 수 있다.
    // 이 경우 문자 발송 등에 쓸 연락처가 아예 비어버리지 않도록 로그인한 회원 정보로 대체한다.
    const input: UpReceiptAddressInput = {
      receiptUuid: `${params.receiptUuid}`,
      howToReceive: HowToReceive.PickUp,
      portId: selectedPort.id,
      address: `${selectedPort.address}`,
      receiver: selectedAddress?.username || me?.me.name,
      phone: selectedAddress?.phone || me?.me.phone,
      pass: selectedAddress?.pass,
      message: selectedAddress?.message,
      region: selectedAddress?.region,
    };
    upReceiptAddress({ variables: { input } });
  };

  //  카카오맵
  const { loading, error } = useInjectKakaoMapApi({
    appkey: String(process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY),
  });
  return (
    <div className="wrap h-full flex flex-wrap flex-col ">
      <header className="border-b border-btnLightLine">
        <TopBar
          arrow={true}
          arrowColor={"#B5C1D0"}
          heading={true}
          home={true}
          shop={true}
        />
      </header>
      <main className="flex-1 pb-10 overflow-auto removeScroll relative">
        <div>
          <div id="portSelect" className="pt-4 px-4">
            <p className="h-10 text-xl font-bold px-4 flex flex-wrap content-center">
              <span className="flex-1">픽업장소 선택</span>
            </p>
            <div id="listPickUpPort" className="w-full">
              <div className="w-full">
                {portList &&
                  portList?.length > 0 &&
                  portList?.map((port) => (
                    <div
                      key={`port-${port.id}`}
                      onClick={() => {
                        setSelectedPort(port);
                      }}
                      className={`mt-4 flex flex-wrap flex-col pt-1 px-4 pb-4 rounded-lg bg-bg w-full gap-y-4 ${
                        selectedPort?.id === port.id &&
                        "inner-border inner-border-mainIcon"
                      }`}
                    >
                      <div className="flex flex-wrap gap-x-2 content-center ">
                        <p className="font-bold text-sm leading-8">
                          {port.name}
                        </p>
                      </div>
                      <div className="w-full h-[200px]">
                        {/* 지도 자리*/}
                        {/* 카카오맵 스크립트가 아직 로드되지 않았거나(loading) 로드에 실패했으면(error)
                            Map/MapMarker가 window.kakao를 참조하면서 그대로 터지기 때문에,
                            로드가 끝난 뒤(loading === false && !error)에만 렌더링한다. */}
                        {loading ? (
                          <div className="w-full h-full flex items-center justify-center bg-bg rounded-lg">
                            <CircularProgress size={24} />
                          </div>
                        ) : error ? (
                          <div className="w-full h-full flex items-center justify-center bg-bg rounded-lg text-xs text-grayFont">
                            지도를 불러오지 못했습니다
                          </div>
                        ) : (
                          <Map
                            center={{
                              lat: port.latitude,
                              lng: port.longitude,
                            }}
                            style={{ width: `100%`, height: `100%` }}
                            isPanto
                            level={2}
                          >
                            <MapMarker
                              position={{
                                lat: port.latitude,
                                lng: port.longitude,
                              }}
                            ></MapMarker>
                          </Map>
                        )}
                      </div>
                      <div className="bg-white rounded-lg">
                        <p className="py-1 text-sm flex flex-wrap">
                          <span className="min-w-[60px] text-right px-1">
                            주소
                          </span>
                          <span className="px-1 pl-2 flex-1">
                            {port.address}
                          </span>
                        </p>
                        <p className="py-1 text-sm flex flex-wrap">
                          <span className="min-w-[60px] text-right px-1">
                            연락처
                          </span>
                          <span className="px-1 pl-2 flex-1">{port.phone}</span>
                        </p>
                        <p className="py-1 text-sm flex flex-wrap">
                          <span className="min-w-[60px] text-right px-1">
                            이용시간
                          </span>
                          <span className="px-1 pl-2 flex-1">
                            {port.usageTime}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
                {!portList ||
                  (portList?.length === 0 && (
                    <div className="pt-4 px-4 text-center">
                      픽업 포트가 없습니다
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </main>
      <div className="w-full flex flex-wrap justify-center max-w-screen-fit pb-[25px] pt-[10px] text-center mx-auto gap-x-4">
        <button
          onClick={upReceiptAddressHandler}
          className=" w-52 h-10 text-white bg-mainIcon  text-standard  rounded-full "
        >
          확인
        </button>
      </div>
      {RestLoading && (
        <div className="absolute left-0 top-0 w-screen h-screen bg-black bg-opacity-20 z-10">
          <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <CircularProgress />
          </div>
        </div>
      )}
      <Dialog open={alertOpen} className="relative">
        <AlertComponent
          title={`알림`}
          desc={alertText}
          closeFunction={closeAlert}
        ></AlertComponent>
      </Dialog>
    </div>
  );
};
